import styled from 'styled-components';
import { colors } from '_styles';

const Details = styled.div`

  b {
    all: initial;
  font-family: Roboto, sans-serif !important;
    display: block;
    margin-bottom: 4px;
    font-size: 15px !important;
    font-weight: 400 !important;
    margin: 0;
    text-align: left !important;
  }
  p {
    all: initial; 
    font-family: Roboto, sans-serif !important;
    font-weight: 500 !important;
    display: block;
    font-size: 15px !important;
    line-height: 24px !important;
    margin: 0;
    text-align: left !important;
  }
  ul {
    list-style: disc;
    padding-left: 35px;
    box-sizing: border-box;
    margin-top: 0 !important;
    line-height: 2em !important;
    margin-bottom: 20px !important;
    text-align: left !important;

    li {
      all: initial;
      font-family: Roboto, sans-serif !important;
      list-style: disc;
      font-size: 16px !important;
      line-height: 2em !important;
      color: black;
      display: block;
      text-align: left !important;
    }
  }
  a {
    all: initial;
    font-family: Roboto, sans-serif !important;
    display: inline;
    font-weight: bold !important;
    font-size: 16px !important;
    text-decoration: none !important;
    cursor: pointer;
    border-bottom: 1px solid transparent !important;
    padding-bottom: 3px !important;
    margin: 0;
    text-align: left !important;
    &::-moz-focus-inner {
      border: 0;
    }

    color: ${colors.RC_ACTION} !important;
    text-decoration: none !important;

    &:hover {
      color: ${colors.RC_ACTION} !important;
      text-decoration: none !important;
      border-bottom: 1px solid #11A9CE !important;
      padding-bottom: 3px !important;
    }
  }
`;

export default Details;
